module.exports = __webpack_public_path__ + "static/media/yuce020.3281e803.jpg";